import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase } from 't4core';

@Component({
    selector: 't4-SmsDialog',
    templateUrl: 'SmsDialog.html',
})
export class SmsDialog extends DialogBase {
    public rentalId: number;
    public receiver: string;
    public message: string;

    public sending: boolean = false;

    constructor(public dialogRef: MatDialogRef < SmsDialog >, @Inject(MAT_DIALOG_DATA) public data: any) {
        super("SmsDialog");

      if (data.serviceGuy) {
        this.receiver = data.serviceGuy.Firstname;
      }
      else if (!data.rentalId) {
          alert("Rental id is missing");
          dialogRef.close();
      }

            this.rentalId = data.rentalId;
        if (data.receiver) this.receiver = data.receiver;
        if (data.message) this.message = data.message;
    }

    public send() {
      this.sending = true;
      if (this.data.serviceGuy) {
        this.Api.post("Messaging/SendSmsServiceGuy", null, { serviceGuyId: this.data.serviceGuy.Id, message: this.message, requestId: this.data.requestId }).then(x => {
          this.sending = false;
          if (x == "OK") {
            this.dialogRef.close(this.message);
          }
          else {
            console.log("Error");
            console.log(x);
            alert("Error:" + x)
          }
        })
      }
      else {
        this.Api.post("Messaging/SendSms?rentalId=" + this.rentalId + "&message=" + this.message, this.message).then(x => {
          this.sending = false;
          if (x == "OK") this.dialogRef.close();
        })
      }
       
    }
}
